import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Table, Heading } from '@pretamanger/component-library'

export const NutritionalWrapper = styled('div')`
  ${tw`lg:w-full mx-auto`}
`

export const StyledTable = styled(Table)`
  ${tw`w-full text-gray-700`}

  thead {
    tr {
      ${tw`h-16`}
    }

    th:first-of-type {
      ${tw`sr-only`}
    }

    th {
      ${tw`text-grey-500 font-normal mb-2`}
    }
  }

  td,
  th {
    ${tw`px-3`}
  }

  tr {
    ${tw`h-10`}
  }

  tr:nth-of-type(even) {
    ${tw`bg-grey-100`}
  }

  tbody th {
    ${tw`font-normal`}
  }

  .column-A {
    ${tw`text-left`}
  }

  .column-B,
  .column-C {
    ${tw`text-right`}
  }
`

export const HeadingContainer = styled('div')`
  ${tw`flex justify-between flex-wrap`}
`

export const NutritionalHeading = styled(Heading)`
  ${tw`flex-none text-2xl leading-2xl tracking-lg md:text-3xl md:leading-3xl md:tracking-lg`}
`

export const NoticeWrapper = styled.div`
  margin-top: -20px;
  margin-bottom: -20px;
`
